
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import Spinner from "../component/Spinner";
import CauHoiRenderer from "./CauHoiRenderer";

const TRANG_THAI = {
    dang_lam: { label: "Đang làm", cls: "badge-secondary" },
    cho_cham: { label: "Chờ chấm (có câu tự luận)", cls: "badge-warning" },
    da_cham: { label: "Đã chấm", cls: "badge-success" },
};

export default function KetQuaBaiLam() {
    const { id } = useParams(); // bailam_id
    const { user } = useSelector((state) => state.auth);
    const [bailam, setBailam] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id > 0) {
            setLoading(true);
            Axios.get(URL_LIST_ALL + "learninghub_bailam/" + id, user.config)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === "success") setBailam(res.data.data);
                    else console.log(res.data.message);
                })
                .catch((err) => { console.log(err); setLoading(false); });
        }
    }, [user, id]);

    const parse = (v) => { try { return typeof v === 'object' ? v : JSON.parse(v); } catch (e) { return v; } };
    const tt = bailam ? (TRANG_THAI[bailam.trang_thai] || { label: bailam.trang_thai, cls: 'badge-secondary' }) : null;

    // Thời lượng làm bài = time_submit - time_start (giây) -> "X phút Y giây"
    const fmtDuration = (start, end) => {
        if (!start || !end || end < start) return null;
        const s = end - start;
        const m = Math.floor(s / 60), ss = s % 60;
        return (m > 0 ? m + ' phút ' : '') + ss + ' giây';
    };
    const duration = bailam ? fmtDuration(bailam.time_start, bailam.time_submit) : null;

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li>Kết quả bài làm</li>
                </ul>
            </div>
            {loading && <div className="w-100 text-center"><Spinner /></div>}
            {bailam &&
                <div className="card height-auto mt-2">
                    <div className="card-body">
                        <h3>{bailam.dethi_title}</h3>
                        <div className="d-flex align-items-center mb-3" style={{ gap: 16 }}>
                            <span className={"badge " + tt.cls} style={{ fontSize: 14 }}>{tt.label}</span>
                            {bailam.trang_thai === 'da_cham'
                                ? <h4 className="m-0 text-success">Điểm: {bailam.tong_diem} / {bailam.dethi_tong_diem}</h4>
                                : <h5 className="m-0 text-info">Điểm tạm tính (phần khách quan): {bailam.diem_tu_dong}</h5>}
                            {duration && <span className="text-muted"><span className="far fa-clock"></span> Thời gian làm: {duration}</span>}
                        </div>

                        {(bailam.list_chitiet || []).map((c, idx) => {
                            const traloi = parse(c.tra_loi);
                            const isEssay = c.loai === 'essay';
                            return (
                                <div className="border rounded p-3 mb-3" key={c.id}>
                                    <div className="d-flex justify-content-between">
                                        <strong>Câu {idx + 1}</strong>
                                        <span>
                                            {!isEssay && (c.dung === 1
                                                ? <span className="badge badge-success">Đúng</span>
                                                : <span className="badge badge-danger">Sai</span>)}
                                            {isEssay && c.dung === null && <span className="badge badge-warning">Tự luận - chờ chấm</span>}
                                            <span className="badge badge-primary ml-1">{c.diem_dat} / {c.diem_cau} điểm</span>
                                        </span>
                                    </div>
                                    <div className="mt-1 mb-2" dangerouslySetInnerHTML={{ __html: c.cauhoi_title }} />
                                    {isEssay
                                        ? <div className="bg-light p-2 rounded"><em>Bài làm:</em><br />{traloi || <span className="text-muted">(không trả lời)</span>}</div>
                                        : <CauHoiRenderer cauhoi={c} value={traloi} readOnly={true} correct={c.dapan} />}
                                    {c.nhan_xet && <div className="alert alert-info mt-2 mb-0"><strong>Nhận xét GV:</strong> {c.nhan_xet}</div>}
                                </div>
                            );
                        })}
                    </div>
                </div>
            }
        </AkkhorLayout>
    );
}
